import request from '@aned/request';

// 导入保存
export async function getBoard(params) {
  return request('/api/static/cashing/rate/waybillDurationBoardKWire', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module:"basic"
  });
}

export async function getList(params) {
  return request('/api/static/cashing/rate/waybillDurationBoard', {
    method: 'POST',
    body: params,
    reqType: 'json',
    module:"basic"
  });
}